__turbopack_context__.v({
  "contact-form": "ContactForm-module-scss-module__mA_RQG__contact-form",
  "error": "ContactForm-module-scss-module__mA_RQG__error",
  "field": "ContactForm-module-scss-module__mA_RQG__field",
  "form-error": "ContactForm-module-scss-module__mA_RQG__form-error",
  "honeypot": "ContactForm-module-scss-module__mA_RQG__honeypot",
  "success": "ContactForm-module-scss-module__mA_RQG__success",
  "success-body": "ContactForm-module-scss-module__mA_RQG__success-body",
  "success-heading": "ContactForm-module-scss-module__mA_RQG__success-heading",
});
